import { useMemo, useState } from 'react';
import { useTranslate } from 'b2b-apps/shop/i18n/hooks';
import {
  getCategoriesFiltersFromComparisonItems,
} from 'b2b-apps/shop/product/utils/getCategoriesFiltersFromComparisonItems';
import { ComparedProduct } from 'b2b-common/core/product/api/ProductsCompare.types';

type CategoryFilterType = {
  value: string;
  count: number;
  label: string;
}

type UseFilterComparedProductsReturnType = {
  categories: CategoryFilterType[],
  selectedCategory: string;
  onCategoryChange: (category: string) => void;
  filteredProducts: ComparedProduct[];
}

const useFilterComparedProducts = (products: ComparedProduct[]): UseFilterComparedProductsReturnType => {
  const t = useTranslate();
  const allFiltersLabel = t('All');
  const categories = useMemo(() => getCategoriesFiltersFromComparisonItems(products, allFiltersLabel), []);
  const defaultCategory = products[products.length - 1].details.categoryName;
  const [selectedCategory, setSelectedCategory] = useState<string | null>(defaultCategory || null);
  const filteredProducts = selectedCategory
    ? products.filter(product => product.details.categoryName === selectedCategory)
    : products;

  return {
    categories,
    selectedCategory,
    onCategoryChange: setSelectedCategory,
    filteredProducts,
  };
};

export { useFilterComparedProducts };
export type { CategoryFilterType };
